"use strict";
/*
 * Created on 21. 02. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var FinalProductPrice_1 = require("../../release/model/FinalProductPrice");

var PriceComment_1 = require("../../release/model/PriceComment");
/**
 * Part of PriceZoneReleasePrices
 * @author SKu
 */


var PriceChangeReportPricesDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceChangeReportPricesDTO, _DomainObject_1$Domai);

  /**
   * Creates release item prices for given price zone.
   * @param pricingAreaId GosId for regular releases & SiteId for Sellout
   * @param finalPrice final price for item re-pricing (will become the new regular price of product)
   * @param comments list of comments (comments on final price)
   */
  function PriceChangeReportPricesDTO(pricingAreaId, finalPrice, comments) {
    var _this;

    _classCallCheck(this, PriceChangeReportPricesDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportPricesDTO).call(this));
    _this.pricingAreaId = pricingAreaId;
    _this.finalPrice = finalPrice;
    _this.comments = comments;
    return _this;
  }

  _createClass(PriceChangeReportPricesDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PriceChangeReportPricesDTO(mat.pricingAreaId, mat.finalPrice, mat.comments);
    }
  }]);

  return PriceChangeReportPricesDTO;
}(DomainObject_1.DomainObject);

exports.PriceChangeReportPricesDTO = PriceChangeReportPricesDTO;

PriceChangeReportPricesDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceChangeReportPricesDTO.name);
  return {
    pricingAreaId: builder.str('priceZoneId'),
    finalPrice: builder.obj('finalPrice', FinalProductPrice_1.FinalProductPrice.schema, function (mat) {
      return FinalProductPrice_1.FinalProductPrice.fromDataDict(mat);
    }),
    comments: builder.listOf(builder.obj('comments', PriceComment_1.PriceComment.schema, function (mat) {
      return new PriceComment_1.PriceComment(mat.id, mat.releaseId, mat.priceZoneId, mat.userId, mat.username, mat.productId, mat.text, mat.persistent, mat.deleteOn);
    }))
  };
}();